/* Preserve visible autoplay without downloading every off-screen video on arrival. */
(function () {
  'use strict';
  if (window.HydroLiteMedia) return;
  var states = new WeakMap();
  var videos = new Set();
  function hydrate(video) {
    var changed = false;
    [video].concat(Array.from(video.querySelectorAll('source'))).forEach(function (node) {
      var src = node.getAttribute('data-hydrolite-src');
      if (src && !node.hasAttribute('src')) {
        node.setAttribute('src', src);
        changed = true;
      }
    });
    if (changed) video.load();
  }
  function play(video, manual) {
    var state = states.get(video);
    if (!state) { scan(video); state = states.get(video); }
    if (!state) return;
    if (manual) state.pausedByUser = false;
    if (state.pausedByUser || document.hidden) return;
    hydrate(video);
    var result = video.play();
    if (result && result.catch) result.catch(function () {});
  }
  function pause(video, manual) {
    var state = states.get(video);
    if (state && manual) state.pausedByUser = true;
    video.pause();
  }
  var observer = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var state = states.get(entry.target);
      if (!state) return;
      state.visible = entry.isIntersecting && entry.intersectionRatio > 0;
      if (state.visible) play(entry.target, false);
      else pause(entry.target, false);
    });
  }, { threshold: 0.01 }) : null;
  function loadPoster(video) {
    var poster = video.getAttribute('data-hydrolite-poster');
    if (poster) { video.poster = poster; video.removeAttribute('data-hydrolite-poster'); }
  }
  var posterObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) { loadPoster(entry.target); posterObserver.unobserve(entry.target); }
    });
  }, { rootMargin: '300px 0px' }) : null;
  function scan(root) {
    var found = root.matches && root.matches('video[data-hydrolite-autoplay]') ? [root] : [];
    found = found.concat(Array.from(root.querySelectorAll('video[data-hydrolite-autoplay]')));
    found.forEach(function (video) {
      if (states.has(video)) return;
      states.set(video, { visible: !observer, pausedByUser: false });
      videos.add(video);
      video.playsInline = true;
      if (posterObserver) posterObserver.observe(video);
      else loadPoster(video);
      if (observer) observer.observe(video);
      else play(video, false);
    });
  }
  window.HydroLiteMedia = {
    play: function (video) { play(video, true); },
    pause: function (video) { pause(video, true); },
    toggle: function (video) { if (video.paused) play(video, true); else pause(video, true); }
  };
  document.addEventListener('visibilitychange', function () {
    videos.forEach(function (video) {
      if (document.hidden) pause(video, false);
      else if (states.get(video).visible) play(video, false);
    });
  });
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    videos.forEach(function (video) {
      if (event.target.contains(video)) {
        pause(video, false);
        if (observer) observer.unobserve(video);
        if (posterObserver) posterObserver.unobserve(video);
        videos.delete(video);
        states.delete(video);
      }
    });
  });
  scan(document);
})();
